import { render, staticRenderFns } from "./DonationInfoDialog.vue?vue&type=template&id=2180ce89"
import script from "./DonationInfoDialog.vue?vue&type=script&lang=js"
export * from "./DonationInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports